import { defineConnectorConstellationDerivation, defineConnectorItemDerivation, toConnectorItemCollectionDerivation } from '@toolproof-core/visualization/derivation/_pure/derivation-values';
import { buildLineGuideShape } from '@toolproof-core/visualization/_pure/shapes';
import { toNodeItemKey } from '../keyCodec';
import type { Config } from '../../_contract/config';
import type { deriveLayeredTree } from './layeredTree';

export function deriveLayeredConnections(tree: ReturnType<typeof deriveLayeredTree>, config: Config) {
    const nodeByPath = new Map(tree.nodes.map(node => [node.path, node]));
    const itemCollectionKey = 'collection:connector:core:layered-tree';
    const items = toConnectorItemCollectionDerivation({
        itemCollectionKey,
        itemDerivations: tree.connections.map(connection => defineConnectorItemDerivation({
            item: {
                itemKind: 'connector', itemKey: `item:connector:core:tree:${encodeURIComponent(connection.key)}`,
                shape: buildLineGuideShape(),
                endpoints: {
                    from: { endpointKind: 'static', itemKey: toNodeItemKey(connection.fromPath), anchorKey: 'center' },
                    to: { endpointKind: 'static', itemKey: toNodeItemKey(connection.toPath), anchorKey: 'center' },
                },
            },
            parametricState: {
                endpointPositions: {
                    from: connection.from, to: connection.to,
                },
                visualStyle: { color: config.visualStyle.directoryColor,
                    opacity: connection.key.startsWith('child:') && nodeByPath.get(connection.toPath)?.nodeKind === 'file'
                        ? 0.18 : 0.45 },
            },
        })),
    });
    const constellation = defineConnectorConstellationDerivation({
        constellation: { constellationKind: 'connector', constellationKey: 'constellation:connector:core:layered-tree', itemCollectionKey },
    });
    return { items, constellation };
}
